export const lightTheme = {
    bg: "rgb(30,42,78)",
    bgAlpha: "rgba(4,14,24.3)",
    bg2: "rgb(233 242 247)",
    bg3: "rgb(7 22 39)",
    text: "rgb(247,236,225)",
    primary: "rgb(233,83,13)",
};

export const darkTheme = {
    bg: "rgb(15,15,15)",
    bgAlpha: "rgba(0,0,0,.3)",
    bg2: "rgb(30,30,30)",
    bg3: "rgb(50,50,50)",
    text: "rgb(210,210,210)",
    primary: "rgb(52, 131, 235)",
};
